jQuery(document).ready(function($){
  $('.slide-imgs').each(function(){
    $(this).slick({
      dots: true,
      appendArrows: $('.arrows-container'),
      appendDots: $('.dots-container'),
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false
    })
  });

});
